import apiClientOC from "icfrontendapiclient";
import { useApiClient } from "./useApiClient";
const useBizApiClient = ({
  name,
  method,
  path,
  defaultValue = null,
  formatResultFunc = unformattedResult => unformattedResult,
  preventStateResult = false
}) => {
  const bizApiClient = apiClientOC.get("BizApiClient");
  const [sendRequest, result] = useApiClient({
    apiClient: bizApiClient,
    name,
    method,
    path,
    defaultValue,
    formatResultFunc,
    preventStateResult
  });
  return [sendRequest, result];
};
export { useBizApiClient };